<template>
  <div
    v-if="reminder"
    class="card mb-2 rounded-md overflow-hidden"
  >
    <status
      v-if="reminder.type === REMINDER_STATUS"
      :reminder="reminder"
    />

    <type
      v-if="reminder.type === REMINDER_TYPE"
      :reminder="reminder"
    />
  </div>
</template>
<script>
import mapReminders from "@providers/mapReminders";
import Status from "@components/Dashboard/Views/Pages/Training/Components/ReminderStatus.vue";
import Type from "@components/Dashboard/Views/Pages/Training/Components/ReminderType.vue";

export default {
  components: { Status, Type },
  props: {
    type: {
      type: String,
      default: () => ""
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      reminder: null
    };
  },
  computed: {},
  created() {
    this.REMINDER_STATUS = "STATUS";
    this.REMINDER_TYPE = "TYPE";
  },
  async mounted() {
    this.reminder = this.resolveReminder(this.item);
  },
  methods: {
    resolveReminder(reminder) {
      if (!reminder) {
        return reminder;
      }

      const foundReminder = mapReminders.find(
        ({ id: itemKey }) => reminder.id === itemKey
      );

      return { ...foundReminder, ...reminder };
    }
  }
};
</script>

<style lang="scss"></style>
